import { useEffectOnce, useLatest } from 'react-use';

/**
 * Fires a callback exactly once on mount, using a stable ref to avoid
 * stale closures. Safe to pass a callback that changes across renders —
 * only the initial value will be invoked.
 */
export function useOnMountCallback(callback?: () => void) {
  const ref = useLatest(callback);
  useEffectOnce(() => {
    ref.current?.();
  });
}
